import * as t from 'io-ts'

import { Config } from '@recordset-local/types/server/api'
import { request, IApiRequest } from '../request'
import { ApiCalls } from '../constants'

export const configRequest = async (apiRequest: IApiRequest<t.TypeOf<typeof Config>>) =>
  request(t.type({ config: Config }), apiRequest.apiUrl)(ApiCalls.CONFIG, { method: 'GET' })
